import { Fragment, useContext, useEffect, useRef } from 'react'
import { InitialStateContext } from '../../App'
import type { IEventWithStream } from '../../App'
import type { IEvent } from '../../api/dto/IEvent'
import { formatDate } from '../../assets/constants/date'
import GameTableItem from '../gameTableItem/gameTableItem'

interface IProps {
    allEvents: IEvent[]
    currentEvent: IEventWithStream | null
    handleSetCurrentEvent: (item: IEventWithStream, isRefresh?: boolean) => void
}

const DatesTableItems = ({
    allEvents,
    handleSetCurrentEvent,
    currentEvent,
}: IProps) => {
    const hasScrolled = useRef(false)
    const selectedElementRef = useRef<HTMLDivElement>(null)
    const { differanceTimeZoneInMs } = useContext(InitialStateContext)
    const dateFunc = (startTime: number) =>
        new Date(startTime * 1000 + differanceTimeZoneInMs).toDateString()
    const dates = Array.from(
        new Set(allEvents.map((elem) => dateFunc(elem.start_time)))
    )
    const dateArrayObj = dates.map((elem) => ({
        date: elem,
        array: allEvents.filter(
            (filter) => dateFunc(filter.start_time) === elem
        ),
    }))

    useEffect(() => {
        if (selectedElementRef.current && !hasScrolled.current) {
            hasScrolled.current = true
            selectedElementRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
        }
    }, [currentEvent, selectedElementRef])

    return (
        <div className="p-2">
            {dateArrayObj.map((dateEl, i) => (
                <Fragment key={i}>
                    <div
                        className={`${i === 0 ? 'mb-[10px]' : 'my-[10px]'} text-violet px-2 text-[16px]`}
                    >
                        {formatDate(`${dateEl.date}`, 'WW, MMMM dd')}
                    </div>
                    {dateEl.array.map((elem) => (
                        <GameTableItem
                            isSelected={currentEvent?.event?.uuid === elem.uuid}
                            key={elem.uuid}
                            onClick={() =>
                                handleSetCurrentEvent({ event: elem })
                            }
                            match={elem}
                            ref={
                                currentEvent?.event?.uuid === elem.uuid
                                    ? selectedElementRef
                                    : undefined
                            }
                        />
                    ))}
                </Fragment>
            ))}
        </div>
    )
}

export default DatesTableItems
